import getBasePath from '../../../../common/functions/api-resource';
import resourceBuilder from '../../../../common/functions/metadados-resource-builder';

const basePath = getBasePath('planejamento_acao', '');

const planejamentoAcaoActions = {
  buscarAcao: { methods: 'GET', url: `${basePath}carregamento/{idAcao}` },
  verificarSeUsuarioPossuiAcesso: { methods: 'GET', url: `${basePath}listagem/acesso/{idAcao}` },
};

export default resource => resource(`${basePath}`, {}, planejamentoAcaoActions);

export const buscarTiposAcao = (parametros, resource) =>
  resourceBuilder.buildGET(resource, basePath, 'listagem/tipo_acao', parametros).doGet();

export const buscarAcoes = (parametros, resource) =>
  resourceBuilder.buildGET(resource, basePath, 'listagem/tipo_acao/acoes', parametros).doGet();



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-acao-listagem.js